<template>
  <div class="card-box" :style="{ width: width }">
    <div class="line1"></div>
    <div class="line"></div>
    <div class="title">
      <div>{{ title }}</div>
    </div>
    <div class="card-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    width: String,
  },
};
</script>

<style lang="less" scoped>
.card-box {
  width: 432px;
  position: relative;
  min-height: 300px;
  .card-content {
    width: 100%;
  }
  .title {
    line-height: 52px;
    text-align: center;
    vertical-align: middle;
    width: 120px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    font-size: 24px;
  }
  .line1 {
    width: 100%;
    height: 1px;
    background-color: #ededed;
  }
  .line {
    width: 128px;
    height: 2px;
    background-color: #cb3333;
    position: absolute;
    top: 0;
  }
}
</style>